<template>
  <!-- eslint-disable-next-line vue/no-mutating-props -->
  <el-dialog title="审批动态" :visible.sync="approvalTaskDetailDialogVisible" width="824px" :before-close="closeDialog">
    <div v-loading="loading" class="step_list_box">
      <div v-if="stepList.length > 0">
        <el-timeline>
          <el-timeline-item
            v-for="(step, index) in stepList"
            :key="index"
            :type="step.color"
            :title="step.categoryName"
            :timestamp="step.operateTime"
            >{{ step.content || '' }}</el-timeline-item
          >
        </el-timeline>
      </div>
      <div v-else>--</div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog" type="primary">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { approvalTaskDetail } from '@/api/approvalApi'

export default {
  name: 'ApprovalTaskDetail',
  props: {
    approvalTaskDetailDialogVisible: {
      type: Boolean,
      default: () => false,
    },
    bizId: {
      type: [String, Number],
      default: '',
    },
    bizType: {
      type: [String, Number],
      default: '',
    },
    id: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      // dialogVisible: false,
      loading: false,
      types: {
        1: { title: '提交申请', color: 'success' },
        2: { title: '一级审批', color: 'primary' },
        3: { title: '撤回申请', color: 'warning' },
        4: { title: '抄送', color: 'primary' },
      },
      result: {
        '-1': '待审批',
        0: '审批拒绝',
        1: '审批通过',
      },
      stepList: [],
      model: {
        NONE: '单人审批',
        AND: '-会签',
        OR: '或签',
      },
    }
  },
  watch: {
    approvalTaskDetailDialogVisible(n) {
      if (n) {
        this.loading = true
        const params = this.bizType
          ? {
            bizId: this.bizId,
            bizType: this.bizType,
          }
          : {
            id: this.id,
          }
        approvalTaskDetail(params)
          .then((res) => {
            this.loading = false
            if (res.code === 1) {
              this.stepList = res.data.stepList || []
              this.stepList.forEach((step) => {
                step.content = this.formatStepList(step)
              })
            }
          })
          .catch(() => {
            this.loading = false
          })
      }
    },
  },
  methods: {
    formatStepList(step) {
      let content = ''
      // 提交/撤回
      if (step.categoryType === 1 || step.categoryType === 3) {
        step.color = Number(step.categoryType) === 1 ? 'success' : 'warning'
        content = `${step.operatorList.join('、')} ${
          this.types[step.categoryType].title
        }`
      }
      // 抄送
      if (step.categoryType === 4) {
        step.color = 'primary'
        content = `${step.operatorList.join('、')}`
      }
      // N级审批
      if (step.categoryType === 2) {
        step.title = step.categoryName || ''
        // 不通过
        if (!step.result) {
          step.color = 'warning'
        }
        // 通过
        if (step.result === 1) {
          step.color = 'success'
        }
        // 待审批
        if (step.result === -1) {
          step.color = 'primary'
        }
        content = `${step.operatorList.join('、')} ${
          this.model[step.approvalType]
        }  ${this.result[step.result]} `
        // 审批撤回
        // if (this.getApprovalState()) {
        //   content = `${step.operatorList.join('、')} ${this.model[step.approvalType]} 审批撤回`
        // }
      }
      return content
    },
    // 审批是否撤回
    // getApprovalState() {
    //   // console.log(this.stepList)
    //   return this.stepList.find((item) => Number(item.categoryType) === 3)
    // },
    closeDialog() {
      // this.approvalTaskDetailDialogVisible = false
      this.$emit('update:approvalTaskDetailDialogVisible', false)
    },
  },
}
</script>
<style scoped lang="scss">
.step_list_box {
  min-height: 50px;
  padding-top: 5px;
}
.list {
  color: #969799;
  padding-inline-start: 20px;
}
</style>
